import React, {useContext, useRef} from "react";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import Home from "../views/home";
import CustomFooter from "../views/footer";
import Navbar from "../components/navbar";
import {Layout} from 'antd';
import WhatsAppFloatingButton from "../components/WhatsAppFloatingButton";
import AboutUs from "../views/aboutUs";
import VisionMissionScreen from "../views/visionScreen";
import LeadershipComponent from "../views/leadershhipComponent";
import ValuesSection from "../views/values";
import Services from "../views/services";
import {RefsContext} from "../context/refscontext";


gsap.registerPlugin(ScrollTrigger);

function HomePage() {

    const containerRef = useRef(null);
    const {homeRef, aboutRef, servicesRef} = useContext(RefsContext);
    const {Header, Footer, Content} = Layout;

    return (<Layout ref={containerRef} className="flex flex-col min-h-screen bg-white">
        <Header className={' h-0 bg-transparent w-full align-middle justify-center fixed top-1.5 z-30 p-0'}>
            <Navbar/>
        </Header>
        <Content className="space-y-4 flex-1 overflow-y-auto overflow-x-hidden justify-center">
            <div ref={homeRef} className="h-screen items-center justify-center">
                <Home/>
            </div>
            <div
                // ref={aboutRef}
                className="h-auto flex flex-col items-center justify-center">
                <AboutUs aboutRef={aboutRef}/>
            </div>
            <div
                className="h-auto flex flex-col items-center justify-center">
                <VisionMissionScreen/>
            </div>
            <div
                className="h-auto flex flex-col items-center justify-center">
                <LeadershipComponent/>
            </div>
            <div
                className="h-auto flex flex-col items-center justify-center">
                <ValuesSection/>
            </div>
            <div
                ref={servicesRef}
                className="h-auto flex flex-col items-center justify-center">
                <Services/>
            </div>
            {/*<div*/}
            {/*    className="h-auto flex flex-col items-center justify-center">*/}
            {/*    <CustomerReviews/>*/}
            {/*</div>*/}
            <WhatsAppFloatingButton/>
        </Content>
        <Footer className={'p-0'}>
            <CustomFooter/>
        </Footer>
    </Layout>);

}

export default HomePage;
